<template>
  <div>
    <div
      v-if="!loaded"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div v-if="loaded">
      <h1
        v-if="page === 'us-map'"
        class="title is-1 has-text-centered"
      >
        Select your state
      </h1>
      <us-map
        v-if="page === 'us-map'"
        @handleRegion="switchRegion"
      />
      <div v-if="page === 'regions'">
        <p
          class="field"
          @click="showMap()"
        >
          <a class="button">
            <span class="icon">
              <i class="far fa-chevron-left" />
            </span>
            <span>Back</span>
          </a>
        </p>
        <ul class="is-list-style list-region">
          <li v-for="region in regions">
            <router-link :to="{name: 'AccountEdit', params: {region: region.regid}}">
              {{ region.regid }}
            </router-link>: {{ region.name }}
          </li>
        </ul>
        <div v-if="regions.length < 1">
          <p class="text-center">
            Thank you for visiting AHLPoker.com.
          </p>
          <p class="text-center">
            At this time we do not have any venues in your area. However, we are growing rapidly, and will be coming to your area soon.
          </p>
          <p class="text-center">
            If you would like to be notified when a venue becomes available in your area, please enter your e-mail address below. We will contact you as soon as a venue near you opens.
          </p>
          <p class="text-center">
            <strong>See you soon!</strong>
          </p>
          <p class="text-center">
            <label class="label is-size-6-touch"> E-mail Address:</label> <input
              class="input"
              type="email"
              style="width: 220px;"
            > <button
              class="button is-dark"
              type="submit"
            >
              Continue
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UsMap from '../location/UsMap.vue'
  import axios from 'axios'
  export default {
    name: 'SetRegion',
    components: {
      UsMap,
    },
    props: ['user', 'token'],
    data () {
      return {
        page: 'us-map',
        regions: [],
        loaded: true
      }
    },
    methods: {
      switchRegion (state) {
        this.loaded = false
        let url = `general/regions/getbystate/${state}`
        this.$axios({
          method: 'POST',
          url,
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.regions = res.data
            this.page = 'regions'
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
      },
      showMap () {
        this.page = 'us-map'
      }
    }
  }
</script>
